/**
 * "새 폴더" 버튼의 글리프 — 대시보드 파일 박스 헤더(`FileHeader`)와 레이어 패널 검색줄
 * (`LayerSearchEditableList`)의 버튼이 같은 모양으로 선다.
 * import 없는 리프 파일이다 — `FileHeader` 가 폴더 트리 구현을 끌어오지 않고 이름만 읽는다.
 */
export const NEW_FOLDER_ICON = "etc/folder-plus";
